import { render, staticRenderFns } from "./PrevNext.vue?vue&type=template&id=98630dbc"
import script from "./PrevNext.vue?vue&type=script&lang=js"
export * from "./PrevNext.vue?vue&type=script&lang=js"
import style0 from "./PrevNext.vue?vue&type=style&index=0&id=98630dbc&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports